module.exports = __webpack_public_path__ + "static/img/Bike Tours OLD.ad51993.png";